import {changeQuestion, questionList} from './question.js';
import {birdImage, birdName, arrayVariant, booleanRight} from './answer-list.js'
import {descrWrapper, audioInDescription, descrProgress, descrBtn} from './bird-descr.js';
import {audio, loadSong, progress, imgSrc} from './audioplayer.js';
import {birdsData} from './birds-data.js';
import { getRandomIntInclusive } from './random.js';
import { localLanguageEn, localLanguageRu } from "./language.js";

const containerCurrentQuestion = document.querySelector('.container-current-question');

function createNextQuestion () {
  containerCurrentQuestion.style.display = 'grid';
  containerCurrentQuestion.style.gridTemplateColumns = '3fr 1fr';

  let nextQuestion;
  let currentQuestion = document.querySelector('.container-question__question-active');
  for (let i = 0; i < questionList.length; i++) {
    if (questionList[i] == currentQuestion) {
      nextQuestion = questionList[i+1];
    }
  }

  let divNextQuestion = document.createElement('div');
  containerCurrentQuestion.appendChild(divNextQuestion);
  divNextQuestion.classList.add('next-question');
  if (nextQuestion == null) { //TODO maybe error, maybe divNextQuestion should be used instead
    divNextQuestion.textContent = localStorage.getItem("lang") === null ?  localLanguageRu.game.toResults : localStorage.getItem("lang") === "Русский" ? localLanguageRu.game.toResults : localLanguageEn.game.toResults;
  } else {
    divNextQuestion.textContent = localStorage.getItem("lang") === null ?  localLanguageRu.game.nextQuestion : localStorage.getItem("lang") === "Русский" ? localLanguageRu.game.nextQuestion : localLanguageEn.game.nextQuestion;
  }
  
  divNextQuestion.onclick = function () {
    changeQuestion();
    deleteButtonNextQuestion (divNextQuestion);
    restartData ();
    choseSoundCategory ();
    // choseAnswerListCategory ();
  }
}

function deleteButtonNextQuestion (divNextQuestion) {
  containerCurrentQuestion.removeChild(divNextQuestion);
  containerCurrentQuestion.style.gridTemplateColumns = "1fr";
}

function restartData () {
  birdImage.src = "./assets/image/for-html/birb-sing-fun-bw.jpg";
  birdName.innerHTML = '************';
  audio.src = '';
  progress.style.width = '0%';
  imgSrc.classList.remove('play');
  imgSrc.src = './assets/image/for-html/play_circle.png';
  audioInDescription.src = '';
  descrProgress.style.width = '0%';
  descrBtn.classList.remove('play');
  descrBtn.src = './assets/image/for-html/play_circle.png';
  for (let name of arrayVariant) {
    name.classList.remove('chose-answer__variant_right-answer');
    name.previousElementSibling.classList.remove('chose-answer__input-radio_right-answer');
    name.classList.remove('chose-answer__variant_wrong-answer');
    name.previousElementSibling.classList.remove('chose-answer__input-radio_wrong-answer');
  }
  for (let i of descrWrapper.children) {
    i.style.visibility = 'hidden';
  }
}

function choseSoundCategory () {
  for (let i = 0; i < questionList.length; i++) {
    // console.log(questionList[i]);
    if (questionList[i].classList.contains('container-question__question-active')) {
      // console.log("in if")
      let objectBird = birdsData[i][getRandomIntInclusive(0, birdsData[i].length - 1)];
      let chosenCategory = birdsData[i];
      loadSong(objectBird);
      setVariantAnswerList (chosenCategory);
    }
  }
}

// choseSoundCategory ();

function setVariantAnswerList (chosenCategory) {
  for (let name of arrayVariant) {
    name.innerHTML = '';
  }
  let shuffledArray = shuffle(chosenCategory);
  for (let i = 0; i < arrayVariant.length; i++) {
    arrayVariant[i].innerHTML = shuffledArray[i].name;
    arrayVariant[i].setAttribute('id', shuffledArray[i].id);
  }
}

function shuffle(array) {
  return array.map(value => ({value, sort: Math.random()})) //bind to each element of array random number and form new intermediate array
              .sort((a, b) => a.sort - b.sort) //sort intermediate array by generated random numbers[]
              .map(({value}) => value); //extract actual values (birds/tv series/etc.) to a new array and return
}


export {createNextQuestion, choseSoundCategory};